// @flow
import type { Action } from '../actions/types';
import {
	FETCH_VSHELF,
	FETCH_VSHELF_SUCCESS,
	FETCH_VSHELF_ERROR,
	UPDATE_VSKU_PURCHASE_COUNT,
	RESET_VSHELF,
} from '../actions/types';

import type { CartData } from '../actions/types';
const initialState = {
	virtualShelf: {},
	fetching: false,
	error: null,
};

export const vShelfReducer = (
	state: typeof initialState = initialState,
	{ type, payload }: Action
): typeof initialState => {
	switch (type) {
		case FETCH_VSHELF:
			return {
				...state,
				fetching: true,
				virtualShelf: {},
				error: null,
			};

		case FETCH_VSHELF_SUCCESS:
			return {
				...state,
				fetching: false,
				virtualShelf: payload,
				error: null,
			};

		case FETCH_VSHELF_ERROR:
			return {
				...state,
				fetching: false,
				virtualShelf: {},
				error: payload,
			};

		case UPDATE_VSKU_PURCHASE_COUNT:
			return {
				...state,
				virtualShelf: {
					...state.virtualShelf,
					skus: processUpdatePurchaseCount(payload, state.virtualShelf.skus, state.virtualShelf.shelfSkuMap),
				},
			};

		case RESET_VSHELF:
			return {
				...state,
				fetching: false,
				virtualShelf: {
					skus: new Map(), 
					virtualShelfList: new Map(), 
				},
				error: null,
			};
		default:
			return state;
	}
};

const processUpdatePurchaseCount = (
	cartData: CartData | null = null,
	skus: Map<string, Map<string, { [key: string]: mixed }>> = new Map(),
	shelfSkuMap: Map<string, Set<string>> = new Map()
): Map<string, Map<string, { [key: string]: mixed }>> => {
	if (!cartData || skus.size === 0) {
		return skus;
	}

	let updatedSkuData = {};
	const { vShelfKey } = cartData.skuData;
	const skuMap = skus.get(vShelfKey);
	if (skuMap) {
		const sku = skuMap.get(cartData.skuData.key);
		if (sku) {
			updatedSkuData = { ...sku };
			if (cartData.action === 'ADD') {
				updatedSkuData.purchasedQty = updatedSkuData.purchasedQty ? updatedSkuData.purchasedQty + 1 : 1;
			} else {
				updatedSkuData.purchasedQty = updatedSkuData.purchasedQty ? updatedSkuData.purchasedQty - 1 : 0;
			}
			skuMap.set(cartData.skuData.key, updatedSkuData);
			skus.set(vShelfKey, new Map(skuMap));
			const shelfSet = shelfSkuMap.get((sku: any).key);
			if (shelfSet) {
				const shelfArray: Array<string> = [...shelfSet];
				shelfArray
					.filter((shelf) => shelf !== vShelfKey)
					.forEach((shelf) => {
						const skuMap = skus.get(shelf);
						if (skuMap) {
							skuMap.set(cartData.skuData.key, updatedSkuData);
							skus.set(vShelfKey, new Map(skuMap));
						}
					});
			}
		}
	}

	return new Map(skus);
};
